<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.game.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.game.list.title"></app-i18n>
      </h1>

      <app-game-list-toolbar></app-game-list-toolbar>
      <app-game-list-filter></app-game-list-filter>
      <app-game-list-table></app-game-list-table>
    </div>
  </div>
</template>

<script>
import GameListFilter from '@modules/game/components/game-list-filter.vue';
import GameListTable from '@modules/game/components/game-list-table.vue';
import GameListToolbar from '@modules/game/components/game-list-toolbar.vue';

export default {
  name: 'app-game-list-page',

  components: {
    [GameListFilter.name]: GameListFilter,
    [GameListTable.name]: GameListTable,
    [GameListToolbar.name]: GameListToolbar,
  },
};
</script>

<style>
</style>
